import { render, staticRenderFns } from "./shopadministrationdetail.vue?vue&type=template&id=2233a7f5&scoped=true&"
import script from "./shopadministrationdetail.vue?vue&type=script&lang=js&"
export * from "./shopadministrationdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233a7f5",
  null
  
)

export default component.exports